<template>
    <canvas id="occupancy-chart" width="90%" height="40%"></canvas>
</template>

<script>
    export default {
        props: ['occupancy'],
        name: "admin-dash-occupancy-graph",
        watch: {
            occupancy: function () {
                this.drawChart();
            }
        },
        methods: {
            getGraphData: function () {
                let graphDataArray = [];

                this.occupancy.forEach(function (element) {
                    let tempDate = new Date(element.date);

                    graphDataArray.push({
                        x: tempDate,
                        y: element.occupancyrate
                    });
                });

                return graphDataArray;
            },
            drawChart: function () {
                let graphElement = $("#occupancy-chart");
                let options = {
                    tooltips: {
                        mode: 'index',
                        callbacks: {
                            title: function (tooltipItem, chart) {
                                let returnString = new Date(tooltipItem[0].xLabel).toLocaleDateString(window.navigator.language, {
                                        weekday: 'long',
                                        year: 'numeric',
                                        month: 'long',
                                        day: 'numeric'
                                    });
                                return returnString;
                            },
                            label: function (tooltipItem, data) {
                                return " " + number_format_no_zero_decimals(tooltipItem.yLabel, 2, ",", " ") + " %";
                            },
                        }
                    },
                    responsive: true,
                    scales: {
                        yAxes: [{
                            id: 'A',
                            ticks: {
                                beginAtZero: true
                            },
                            offset: true,
                            max: '110',
                        }],
                        xAxes: [{
                            type: 'time',
                            positive: 'bottom',
                            time: {
                                unit: 'day'
                            }
                        }]
                    }
                };

                let data = this.getGraphData();

                let occupancyChart  = new Chart(graphElement, {
                   type: 'line',
                   data: {
                       datasets: [{
                           label: 'Beläggningsgrad i procent',
                           data: data,
                           backgroundColor: 'rgba(255, 99, 132, 0.2)',
                           borderColor: 'rgba(255,99,132,1)',
                           borderWidth: 2
                       },
                       ]
                   },
                   options: options
                });

            }
        }, //methods
        mounted: function () {
            this.drawChart();
        }
    }
</script>

<style scoped>

</style>